<!--
 * @Description:
 * @Author: shufei
 * @Date: 2021-11-04 09:50:04
 * @LastEditTime: 2021-11-19 23:38:43
 * @LastEditors: shufei
-->
<template>
  <div id="app">
    <!-- <transition :name="$store.state.direction"> -->
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view class="router"></router-view>
    </keep-alive>
    <router-view class="router" v-else></router-view>
    <!-- </transition> -->
  </div>
</template>
<script>
// import VConsole from 'vconsole'
export default {
  name: 'App',
  mounted() {
    window.history.pushState(null, null, window.location.href)
    window.onpopstate = function (event) {
      window.history.pushState(null, null, window.location.href)
    }
    // console.log(this.$utils, 'util')
    // if (this.$utils.getQuery().debug) return new VConsole()
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  position: relative;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.router {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
</style>
